import React from 'react';
import cn from '../../lib/bem';
import { validarNumero } from '../../lib/utils/utilitarios';

import './inputText_component.scss';

const InputTextComponent = ({name, placeholder, value, accion, msgValidador, focus, disabled, tipoCampo, maxLength}) => {

    const classes   = cn("inputTextComponent");
    const validador = msgValidador !== "" ? "input-detalle inputDet-validador" : "input-detalle";

    const validarTipoCampo = (valor) => {
        if( tipoCampo === 'text'){
            accion(valor);
        } else if(tipoCampo === 'numeric') {
            if(!validarNumero(valor)){
                return;
            } else {
                accion(valor);
            }
        }
    }

    return (
        <div className={classes()}>
            <input aria-label={name} type='text' className={classes(validador)} name={name} placeholder={`${placeholder}`} value={value} onChange={e => validarTipoCampo(e.target.value)} onFocus={focus} autoComplete='off' maxLength={maxLength} disabled={disabled}/>
            {
                msgValidador !== '' ? <label className={classes('input-detalle-msgValidador')}>{msgValidador}</label> : null 
            }
        </div>
    );

}

export default InputTextComponent
